module.exports = __webpack_public_path__ + "static/how-it-works-hero.a899b9f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/how-it-works/how-it-works-hero.jpg
// module id = 196
// module chunks = 96216660452428 214286880276331